import { useContext } from 'react';

import { QSetListContext } from './qset-list-modal-provider';

function useQSetListModal() {
  const context = useContext(QSetListContext);

  if (!context) {
    throw new Error('useQSetListModal must be used within a QSetListModalProvider');
  }

  return context;
}

export { useQSetListModal };
